import { render, staticRenderFns } from "./JackpotsHistory.vue?vue&type=template&id=9075c1f4&scoped=true&"
import script from "./JackpotsHistory.vue?vue&type=script&lang=js&"
export * from "./JackpotsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9075c1f4",
  null
  
)

export default component.exports